export const FilterType = {
	VALIDATION: 'validation',
	PREPARATION: 'preparation',
};